package pl.michal_cyran.brand_hub

import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.css.functions.toImage
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

import org.jetbrains.compose.web.css.*
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.compose.css.Background
import com.varabyte.kobweb.compose.css.BoxShadow
import com.varabyte.kobweb.compose.css.BoxSizing
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.css.functions.blur
import com.varabyte.kobweb.compose.ui.modifiers.alignSelf
import com.varabyte.kobweb.compose.ui.modifiers.backdropFilter
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderTop
import com.varabyte.kobweb.compose.ui.modifiers.boxSizing
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gridTemplateColumns
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.extendedBy
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle



val BtnStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .height(40.px)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .borderRadius(0.75.cssRem)
            .padding(0.px, 24.px)
            .fontSize(14.px)
            .fontWeight(500)
            .transition(Transition.of("all", 0.2.s))
            .cursor(Cursor.Pointer)
            .gap(8.px)
    }

    hover {
        Modifier.gap(12.px)
    }
}
val BtnPrimaryStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(colorMode.toSitePalette().primary)
            .color(colorMode.toSitePalette().textOnPrimary)
    }
    hover {
        Modifier
//            .backgroundColor(colorMode.toSitePalette().ctaButtonHoverBackground)
    }
}
val BtnOutlineStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(colorMode.toSitePalette().ctaButtonBg)
            .color(colorMode.toSitePalette().ctaButtonText)
            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().borderDefault)
    }
    hover {
        Modifier
            .border { color(colorMode.toSitePalette().borderHover) }
    }
}
val BtnLgStyle = CssStyle.base {
    Modifier
        .height(48.px)
        .padding(0.px, 32.px)
        .display(DisplayStyle.Flex)
        .alignItems(AlignItems.Center)
}

val DarkSectionStyle = CssStyle.base {
    Modifier
        .position(Position.Relative)
        .overflow(Overflow.Hidden)
}

val HeroContainerStyle = CssStyle.base {
    Modifier
        .margin(0.px, autoLength)
        .padding(80.px, 24.px)
}

val HeroGridStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Grid)
            .gap(48.px)
            .alignItems(AlignItems.Center)
    }

    Breakpoint.MD {
        Modifier
            .gridTemplateColumns {
                size(1.fr)
                size(1.fr)
            }
    }
}
val HeroBadgeStyle = CssStyle.base {
    Modifier
        .display(DisplayStyle.Flex)
        .alignItems(AlignItems.Center)
        .gap(8.px)
        .borderRadius(9999.px)
        .border(1.px, LineStyle.Solid, colorMode.toSitePalette().borderHover)
        .backgroundColor(colorMode.toSitePalette().badgeBg)
        .padding(8.px, 16.px)
        .margin(bottom = 24.px)
}
val HeroBadgeDotStyle = CssStyle.base {
    Modifier
        .display(DisplayStyle.Flex)
        .borderRadius(50.percent)
        .backgroundColor(Color.rgb(0x22c55e))
        .animation(Pulse.toAnimation(duration = 2.s, iterationCount = AnimationIterationCount.Infinite))
        .size(8.px)
}
val HeroBadgeTextStyle = CssStyle.base {
    Modifier
        .fontSize(14.px)
        .fontWeight(500)
        .color(colorMode.toSitePalette().badgeText)
}
val HeroTitleStyle = CssStyle.base {
    Modifier
        .fontSize(40.px)
        .fontWeight(700)
        .lineHeight(1.1)
}

val HeroDescriptionStyle = CssStyle.base {
    Modifier
        .fontSize(18.px)
        .lineHeight(1.7)
        .color(colorMode.toSitePalette().textBody)
        .margin(top = 24.px)
}
val HeroButtonsStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .flexWrap(FlexWrap.Wrap)
            .alignItems(AlignItems.Center)
            .gap(16.px)
            .margin(top = 32.px)
    }
    cssRule(" .btn") {
        Modifier
            .gap(8.px)
    }
    cssRule(" .btn:hover") {
        Modifier
            .gap(12.px)
    }
}
val HeroSocialStyle = CssStyle.base {
    Modifier
        .display(DisplayStyle.Flex)
        .alignItems(AlignItems.Center)
        .gap(24.px)
        .margin(top = 40.px)
}
val SocialLinkStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .borderRadius(50.percent)
            .border(1.px, LineStyle.Solid, Color.rgb(0x1e3035))
            .color(Color.rgb(0x94a3b8))
            .transition(Transition.of("all", 0.2.s))
            .size(40.px)
    }
    hover {
        Modifier
            .border { color(Color.rgb(0x22d3ee)) }
            .color(Color.rgb(0x22d3ee))
    }
    cssRule(" svg") {
        Modifier
            .size(20.px)
    }
}
val HeroVisualStyle = CssStyle.base {
    Modifier
}
//val HeroVisualOuterStyle = CssStyle.base {
//    Modifier
//        .borderRadius(24.px)
//        .background(
//            colorMode.toSitePalette().bgSurface
//        )
//}
val HeroVisualInnerStyle = CssStyle {
    base {
        Modifier
            .borderRadius(16.px)
//            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().borderDefault)
//            .backgroundColor(colorMode.toSitePalette().bgSurface)
            .backdropFilter(blur(8.px))
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .gap(16.px)
            .padding(32.px)
    }

    hover {
        Modifier
            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().borderHover)
    }
}
val HeroVisualLogoStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .borderRadius(16.px)
            .backgroundColor(colorMode.toSitePalette().primary)
            .color(colorMode.toSitePalette().textOnPrimary)
            .size(96.px)
    }
    cssRule(" span") {
        Modifier
            .fontSize(48.px)
            .fontWeight(700)
    }
}
val HeroVisualTagsStyle = CssStyle.base {
    Modifier
        .display(DisplayStyle.Flex)
        .flexWrap(FlexWrap.Wrap)
        .justifyContent(JustifyContent.Center)
        .gap(8.px)
        .margin(top = 16.px)
}
val HeroVisualTagStyle = CssStyle.base {
    Modifier
        .borderRadius(9999.px)
        .backgroundColor(Color.rgba(34, 211, 238, 0.1f))
        .padding(4.px, 12.px)
        .fontSize(12.px)
        .fontWeight(500)
        .color(colorMode.toSitePalette().primary)
}
val LightSectionStyle = CssStyle.base {
    Modifier
        .borderTop(1.px, LineStyle.Solid, colorMode.toSitePalette().borderDefault)
        .backgroundColor(colorMode.toSitePalette().bgSectionB)
        .padding(80.px, 0.px)
        .fillMaxWidth()
}
val ServicesTitleStyle = CssStyle.base {
    Modifier
        .fontSize(32.px)
        .fontWeight(700)
        .flexWrap(FlexWrap.WrapReverse)
}
val ServicesSubtitleStyle = CssStyle.base {
    Modifier
        .margin(16.px, autoLength, 0.px)
        .maxWidth(640.px)
        .fontSize(18.px)
        .color(Color.rgb(0x94a3b8))
}
val ServicesGridStyle = CssStyle.base {
    Modifier
        .display(DisplayStyle.Grid)
        .gap(24.px)
        .margin(top = 64.px)
        .gridTemplateColumns {
            size(1.fr)
            size(1.fr)
        }
}
val ServiceCardStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .overflow(Overflow.Hidden)
            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().borderDefault)
            .backgroundColor(colorMode.toSitePalette().cardBg)
            .padding(all=32.px)
            .transition(Transition.of("all", 0.3.s))
    }
    hover {
        Modifier
            .border { color(Color.rgba(34, 211, 238, 0.5f)) }
            .boxShadow(
                BoxShadow.of(0.px, 20.px, 40.px, 0.px, Color.rgba(34, 211, 238, 0.05f)
                )
            )
    }
    cssRule(".featured") {
        Modifier
            .border { color(Color.rgb(0x22d3ee)) }
            .background(
                Background.of(image = linearGradient(Color.rgba(34, 211, 238, 0.1f), Colors.Transparent, 135.deg).toImage())
            )
    }
    cssRule(".featured .service-card-icon") {
        Modifier
            .backgroundColor(Color.rgb(0x22d3ee))
            .color(Color.rgb(0x0a1214))
    }
    cssRule(".featured .service-card-title") {
        Modifier
            .color(Color.rgb(0x22d3ee))
    }
    cssRule(":hover .service-card-link") {
        Modifier
            .gap(12.px)
    }
    cssRule(".featured .service-card-features") {
        Modifier
//            .borderTop(LineStyle.None)
    }
}

val IconBoxStyle = CssStyle {
    base {
        Modifier
            .borderRadius(16.px)
            .backgroundColor(Color.rgba(34, 211, 238, 0.1f))
//            .background(
//                Background.of(
//                    image = linearGradient(135.deg) {
//                        add(Color.rgba(6, 182, 212, 0.2f), 0.percent)
//                        add(Color.rgba(34, 211, 238, 0.1f), 100.percent)
//                    }.toImage()
//                )
//            )
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .padding(12.px)
            .border(1.px, LineStyle.Solid, Color.rgba(6, 182, 212, 0.3f))
            .boxShadow(
                BoxShadow.of(
                    0.px,
                    8.px,
                    24.px,
                    0.px,
                    Color.rgba(6, 182, 212, 0.2f),
                ),
                BoxShadow.of(
                    0.px,
                    1.px,
                    0.px,
                    0.px,
                    Color.rgba(255, 255, 255, 0.1f),
                    true,
                )
            )
            .flexShrink(0)
            .size(80.px)
            .color(colorMode.toSitePalette().primary)
    }

//    base {
//        Modifier
//            .display(DisplayStyle.Flex)
//            .alignItems(AlignItems.Center)
//            .justifyContent(JustifyContent.Center)
//            .color(Color.rgb(0x22d3ee))
//    }
}

val FeaturedIconBoxStyle = IconBoxStyle.extendedBy {
    base {
        Modifier
            .color(colorMode.toSitePalette().textOnPrimary)
    }
}

val FooterStyle = CssStyle.base {
    Modifier
        .borderTop(1.px, LineStyle.Solid, colorMode.toSitePalette().borderDefault)
        .backgroundColor(colorMode.toSitePalette().footerBg)
        .color(colorMode.toSitePalette().footerText)
        .fillMaxWidth()
}
val FooterContainerStyle = CssStyle.base {
    Modifier
        .margin(0.px, autoLength)
        .padding(64.px, 24.px)
}
val FooterGridStyle = CssStyle.base {
    Modifier
        .display(DisplayStyle.Grid)
        .gap(48.px)
        .maxWidth(1280.px)
        .alignSelf(AlignSelf.Center)
}

val FooterContactEmailStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .gap(12.px)
            .fontSize(14.px)
            .color(colorMode.toSitePalette().textHeading)
            .transition(Transition.of("color", 0.2.s))
    }
    hover {
        Modifier
            .color(colorMode.toSitePalette().textOnPrimary)
    }
}
val FooterContactBoxStyle = CssStyle {
    base {
        Modifier
            .borderRadius(0.75.cssRem)
            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().borderDefault)
            .backgroundColor(colorMode.toSitePalette().cardBg)
            .padding(16.px)
            .margin(top = 16.px)
            .color(colorMode.toSitePalette().textBody)
    }
}
val FooterBottomStyle = CssStyle {
    base {
        Modifier
            .borderTop(1.px, LineStyle.Solid, colorMode.toSitePalette().borderDefault)
            .textAlign(TextAlign.Center)
            .margin(top = 48.px)
            .padding(top = 32.px)
    }
    cssRule(" p") {
        Modifier
            .fontSize(14.px)
            .color(colorMode.toSitePalette().textBody)
    }
}

val FeaturesGridStyle = CssStyle {
    Breakpoint.MD {
        Modifier
            .gridTemplateColumns {
                size(2.fr)
                size(1.fr)
            }
    }
}


val SmallText = CssStyle.base {
    Modifier
        .fontSize(0.875.cssRem)
        .lineHeight(1.25.cssRem)
}

val Pulse = Keyframes {
    each(0.percent, 100.percent) {
        Modifier
            .opacity(1)
    }
    50.percent {
        Modifier
            .opacity(0.5)
    }
}



